import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src4014678918/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
